/** @format */

import {ChartType} from 'components/charts/multiline-chart/model/common';
import {TooltipValue} from 'components/charts/multiline-chart/model/tooltip';

const getTooltipValue = ({primary, secondary}: TooltipValue, chartType: ChartType): string => {
  if (chartType === 'secondary') {
    return secondary ? secondary : '';
  }

  return primary;
};

export default getTooltipValue;
